import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";
import { SUPPORTED_LANGUAGES } from "../utils/languageUtils";

const languageDetector = new LanguageDetector();

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    // lng is not set - let the detector handle language selection automatically
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES, // Use the same constant for consistency
    debug: false, // Enable to see detailed language detection logs in browser console
    detection: {
      order: ["querystring", "sessionStorage", "navigator"], // Query param first, then session storage, then browser detection
      lookupQuerystring: "language", // Look for ?language= instead of default ?lng=
      lookupSessionStorage: "language",
      caches: [], // Never auto-cache
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
